import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import Page from '../Page';
import Header from '../Header';
import { NewItemRequestsTable } from './components/Table/Table';
import { FiltersProvider } from './context/FiltersContext';
import { HeaderFilters } from './components/HeaderFilters';
import { FeatureFlagsContext } from '../../Lib/Contexts/FeatureFlagsContext';

export function NewItemRequests() {
  const { flags } = useContext(FeatureFlagsContext);

  if (!flags.new_inspo?.enabled) {
    return <Redirect to="/" />;
  }

  return (
    <Page.Container>
      <Header.Major icon="star" title="New Item Requests" />
      <FiltersProvider>
        <Header.Minor>
          <HeaderFilters />
        </Header.Minor>
        <Page.Content className="h-full !p-0">
          <NewItemRequestsTable />
        </Page.Content>
      </FiltersProvider>
    </Page.Container>
  );
}

export default NewItemRequests;
